// ============================================================
// OMYA Digital Plant – Czech Translation Dictionary
// Usage: import { t } from '@/i18n';  then t('key')
// ============================================================

const cs = {
  // ── Navigation ──
  'nav.main': 'HLAVNÍ',
  'nav.additional': 'DALŠÍ',
  'nav.dashboard': 'Přehled',
  'nav.supplyChain': 'Výrobní řetězec',
  'nav.trucks': 'Příjezdy',
  'nav.planning': 'Plánování',
  'nav.orders': 'Objednávky',
  'nav.sapIntegration': 'SAP Integrace',
  'nav.aiVision': 'AI / VIZE',
  'tour.open': 'Průvodce',
  'tour.next': 'Další',
  'tour.prev': 'Zpět',
  'tour.done': 'Hotovo',
  'tour.welcome.title': 'Vítejte v OMYA Digital Plant',
  'tour.welcome.text': 'Za 2 minuty ukážeme, jak nástroj řeší příjezdy kamionů v Pomezí: dnes 10–15 aut denně nepřijede a nedá vědět. Průvodce můžete kdykoli zavřít a spustit znovu.',
  'tour.states.title': 'Stav dnešních nakládek',
  'tour.states.text': 'Na první pohled vidíte, kolik nakládek je bez informace. Právě tohle číslo chceme každý den dostat co nejníž.',
  'tour.perHour.title': 'Příjezdy po hodinách',
  'tour.perHour.text': 'Ukazuje špičky 6–9 a 12–14 h proti kapacitě bran. Nikomu nediktujeme okna, jen víme, co nás čeká. Červeně jsou auta, o kterých nic nevíme.',
  'tour.banner.title': 'Co vyžaduje akci',
  'tour.banner.text': 'Přehled jen ukazuje, co se děje. Kolik nakládek potřebuje zásah, vidíte tady a jedním klikem jste ve frontě Akcí.',
  'tour.queue.title': 'Fronta Akcí',
  'tour.queue.text': 'Plánovač tu vidí jen to, co musí vyřešit: urgovat, zavolat, poslat odkaz dispečerovi, přeplánovat. Co vyřeší, z fronty zmizí. Cíl je prázdná fronta.',
  'tour.urgency.title': 'Urgence dopravců ve 13:00',
  'tour.urgency.text': 'Ve 13:00 systém porovná plán se skutečností a sám osloví správného dopravce přes SMS, WhatsApp nebo e-mail, v jeho jazyce. Plánovač jen schválí, nebo běží plně automaticky.',
  'tour.replies.title': 'Odpovědi přicházejí živě',
  'tour.replies.text': 'Teď běží ukázka: AI čte odpovědi v polštině, GPS dohledá auto na cestě a kdo neodpoví do 30 minut, tomu systém zavolá. Fronta se sama vyprazdňuje, plánovači zbydou jen dvě nakládky.',
  'tour.stats.title': 'Výsledky v číslech',
  'tour.stats.text': 'Dlouhodobé statistiky: nepřijetí bez avíza, podíl nakládek s informací ve 13:00, urgence a auta na parkovišti v Jeseníku, vždy proti stavu před pilotem.',
  'tour.carriers.title': 'Hodnocení dopravců',
  'tour.carriers.text': 'Kdo avizuje, kdo nepřijíždí a jak rychle odpovídá. Podklad pro operativní kontrakty a jednání o cenách.',
  'tour.restart.title': 'Průvodce kdykoli znovu',
  'tour.restart.text': 'Tímto tlačítkem průvodce spustíte znovu, třeba pro kolegy. Děkujeme za pozornost.',
  'announce.button': 'Odkaz pro dispečera',
  'announce.previewTitle': 'Avizace dopravcem',
  'announce.previewHint': 'Takto stránku uvidí dispečer dopravce v telefonu. Co uloží, hned se propíše do Příjezdů.',
  'announce.openLink': 'Otevřít odkaz v novém okně',
  'announce.msg.saved': 'Avizace dopravce',
  'announce.msg.noTruck': 'Avizace dopravce: dnes nemáme auto',
  'sources.title': 'Zdroje plánu',
  'sources.intro': 'Odkud se plán nakládek (kdo má kdy přijet) může do aplikace dostávat. Pilot začne ručním importem, automatické zdroje přidáme podle toho, co povolí IT OMYA.',
  'sources.pilot': 'Doporučeno pro pilot',
  'sources.status.live': 'Živě',
  'sources.status.demo': 'Demo data',
  'sources.status.ready': 'Připraveno k napojení',
  'sources.effort': 'Náročnost',
  'sources.effortLevel.low': 'nízká',
  'sources.effortLevel.medium': 'střední',
  'sources.effortLevel.high': 'vysoká',
  'sources.needsIt': 'Potřeba IT OMYA',
  'sources.noIt': 'Bez IT OMYA',
  'sources.how': 'Jak to funguje',
  'sources.fromOmya': 'Co potřebujeme od OMYA',
  'sources.lastRun': 'Poslední automatický import dnes v',
  'sources.loadings': 'nakládek ze SAP',
  'sources.open': 'Otevřít import',
  'sources.manual.title': 'Ruční import (Excel, CSV, schránka)',
  'sources.manual.how': 'Plánovač vloží tabulku ze SAP nebo Excelu, aplikace rozpozná sloupce a zkontroluje řádky.',
  'sources.manual.it': 'Nic, funguje hned.',
  'sources.sapEmail.title': 'Denní e-mail ze SAP',
  'sources.sapEmail.how': 'SAP každé ráno pošle report nakládek (XLSX/CSV) na adresu aplikace, ta ho sama načte.',
  'sources.sapEmail.it': 'Naplánovaná úloha v SAP a adresa pro příjem reportu.',
  'sources.folder.title': 'Sdílená složka / SharePoint / SFTP',
  'sources.folder.how': 'Export se ukládá do sdílené složky, aplikace si ho každých 15 minut stáhne.',
  'sources.folder.it': 'Složka a přístup pro aplikaci (účet s právem čtení).',
  'sources.plannerExcel.title': 'Excel plánovačky (Microsoft 365)',
  'sources.plannerExcel.how': 'Plánovačka dál pracuje ve svém Excelu na SharePointu, aplikace ho průběžně čte.',
  'sources.plannerExcel.it': 'Souhlas s aplikací v Microsoft 365 a pevná struktura tabulky.',
  'sources.carrierLink.title': 'Avizace od dopravců',
  'sources.carrierLink.how': 'Dispečer dopravce přes odkaz doplní SPZ, řidiče a příjezd ke svým nakládkám.',
  'sources.carrierLink.it': 'Kontakty na dispečery 4–6 hlavních dopravců.',
  'sources.weighbridge.title': 'Váha a brána',
  'sources.weighbridge.how': 'Vážní systém nebo stav dodávky v SAP říká, kdo vjel a kdo je naložený.',
  'sources.weighbridge.it': 'Přístup k vážnímu systému nebo jeho exportu.',
  'sources.sapDirect.title': 'Přímé napojení na SAP',
  'sources.sapDirect.how': 'Aplikace čte dodávky a přepravy přímo ze SAP (OData / RFC) v reálném čase.',
  'sources.sapDirect.it': 'Technický uživatel a API v SAP, síťový přístup, souhlas globálního IT.',
  'import.title': 'Import plánu',
  'import.done': 'Importováno nakládek',
  'import.xlsxHint': 'Soubor .xlsx zatím neumíme načíst přímo. Zkopírujte tabulku z Excelu (Ctrl+C) a vložte ji sem, nebo ji uložte jako CSV.',
  'import.file': 'Nahrát CSV',
  'import.useSample': 'Vložit ukázková data',
  'import.downloadSample': 'Stáhnout ukázkový soubor',
  'import.paste.title': 'Vložte plán nakládek',
  'import.paste.hint': 'Zkopírujte tabulku ze SAP nebo z Excelu (Ctrl+C) a vložte ji sem (Ctrl+V). První řádek jsou názvy sloupců.',
  'import.paste.placeholder': 'Dodávka\tZákazník\tMateriál\tMnožství\tDopravce\tDatum\tČas\tTyp',
  'import.photo.title': 'Fotka nebo PDF výtisku',
  'import.photo.hint': 'Vyfoťte vytištěný plán. AI vytáhne řádky a vy je jen zkontrolujete.',
  'import.photo.demo': 'Ukázka: načíst z fotky',
  'import.photo.simulated': 'Ukázka: AI načetla řádky z fotky (simulace)',
  'import.photo.upload': 'Nahrát fotku nebo PDF',
  'import.photo.read': 'AI načetla {n} řádků, zkontrolujte je níže.',
  'import.photo.demoNote': 'Bez AI klíče se místo souboru načte ukázkový plán.',
  'import.photo.tooLarge': 'Soubor je větší než 4,8 MB.',
  'import.mapping.title': 'Který sloupec je co',
  'import.mapping.hint': 'Napoprvé zkontrolujte přiřazení. Uloží se a příště se stejný soubor načte sám. * = povinné.',
  'import.mapping.none': '— nepoužít —',
  'import.field.orderId': 'Dodávka',
  'import.field.customer': 'Zákazník',
  'import.field.material': 'Materiál',
  'import.field.weight': 'Množství (t)',
  'import.field.carrier': 'Dopravce',
  'import.field.date': 'Datum',
  'import.field.time': 'Čas',
  'import.field.type': 'Typ (silo/palety)',
  'import.preview.title': 'Kontrola před importem',
  'import.preview.ok': 'V pořádku',
  'import.preview.failed': 'S chybou',
  'import.preview.import': 'Importovat nakládky',
  'import.preview.problems': 'Problém',
  'import.problem.missing.orderId': 'chybí dodávka',
  'import.problem.missing.carrier': 'chybí dopravce',
  'import.problem.missing.date': 'chybí datum',
  'import.problem.missing.time': 'chybí čas',
  'import.problem.missing.material': 'chybí materiál',
  'import.problem.unknownCarrier': 'neznámý dopravce',
  'import.problem.badDate': 'neplatné datum nebo čas',
  'import.problem.pastDate': 'datum v minulosti',
  'import.problem.duplicate': 'dodávka už je v plánu',
  'nav.planSetup': 'Nastavení plánu',
  'nav.stats': 'Statistiky',
  'stats.title': 'Statistiky',
  'stats.demoData': 'Demo data',
  'stats.demoHint': 'Ilustrativní ukázka: takto by vypadaly statistiky po zavedení urgence dopravců. Výchozí čísla podle klienta.',
  'stats.kpiPeriod': 'Průměr posledních 30 dní proti období před pilotem',
  'stats.tab.overview': 'Přehled KPI',
  'stats.tab.carriers': 'Dopravci',
  'stats.carrier.name': 'Dopravce',
  'stats.carrier.trucks': 'aut',
  'stats.carrier.loadings': 'Nakládky',
  'stats.carrier.announcedPct': 'Avizováno',
  'stats.carrier.noShowPct': 'Nepřijetí bez avíza',
  'stats.carrier.outOfHours': 'Bez výkonu',
  'stats.carrier.replyMedian': 'Odpověď (medián)',
  'stats.carrier.onTimePct': 'ETA ±30 min',
  'stats.carrier.legend': 'Šipky: změna proti předchozímu období stejné délky (zelená = lepší). Červeně: nepřijetí bez avíza 15 % a víc. Klikněte na dopravce pro vývoj v čase.',
  'stats.carrier.weeklyNoShows': 'Nepřijetí bez avíza po týdnech',
  'stats.carrier.weeklyOnTime': 'Přesnost ETA po týdnech',
  'stats.carrier.detailHint': 'Podklad pro operativní kontrakty a jednání o cenách s dopravcem. Demo data.',
  'rating.title': 'Měsíční hodnocení dopravce',
  'rating.open': 'Měsíční hodnocení k tisku',
  'rating.back': 'Zpět na dopravce',
  'rating.month': 'Měsíc',
  'rating.partial': 'neúplný',
  'rating.print': 'Tisk',
  'rating.workDays': '{days} pracovních dní',
  'rating.pilotShare': 'automatická urgence {pct} % dní',
  'rating.thisMonth': 'Tento měsíc',
  'rating.prevMonth': 'Předchozí měsíc',
  'rating.change': 'Změna',
  'rating.findings': 'Zjištění',
  'rating.finding.noShowAlarm': 'Nepřijetí bez avíza nad limitem 15 %: téma pro provozní smlouvu.',
  'rating.finding.noShowBetter': 'Nepřijetí bez avíza kleslo proti předchozímu měsíci.',
  'rating.finding.noShowWorse': 'Nepřijetí bez avíza vzrostlo proti předchozímu měsíci.',
  'rating.finding.slowReply': 'Na urgence odpovídá pomalu (medián nad 30 min).',
  'rating.finding.onTime': 'Spolehlivé ETA: 90 % a více příjezdů v okně ±30 min.',
  'rating.notes': 'Poznámky z jednání',
  'rating.footer': 'OMYA Pomezí · Demo data, ukazatele jako v hodnocení dopravců na Statistikách.',
  'csv.export': 'Export CSV',
  'csv.date': 'Datum',
  'csv.pilot': 'Pilot',
  'csv.planned': 'Plánované nakládky',
  'csv.country': 'Země',
  'csv.yes': 'ano',
  'csv.no': 'ne',
  'stats.tab.site': 'Areál',
  'stats.tab.reports': 'Reporty',
  'reports.readyToConnect': 'Připraveno k napojení',
  'reports.send': 'Odeslat e-mailem',
  'reports.sendToast': 'Odesílání e-mailem je připravené k napojení. V demu se nic neodesílá.',
  'reports.daily.title': 'Denní souhrn',
  'reports.daily.schedule': 'Odchází každý pracovní den v 16:00 plánovačům a expedici',
  'reports.daily.planned': 'Plánováno',
  'reports.daily.loaded': 'Naloženo',
  'reports.daily.urgencies': 'Urgence: {total}, z toho {auto} vyřešeno automaticky a {planner} předáno plánovači.',
  'reports.daily.missing': 'Kdo nepřijel',
  'reports.daily.open': 'Zůstalo otevřené, řeší plánovač',
  'reports.daily.none': 'Nic',
  'reports.weekly.title': 'Týdenní report pro vedení',
  'reports.weekly.schedule': 'Odchází v pondělí v 7:00',
  'reports.weekly.thisWeek': 'Tento týden',
  'reports.weekly.worst': 'Nejproblémovější dopravci',
  'reports.weekly.noShowShort': 'bez avíza',
  'stats.site.heatmapTitle': 'Příjezdy podle dne a hodiny',
  'stats.site.heatmapHint': 'Průměrný počet příjezdů za hodinu. Kapacita brány: {capacity} / h',
  'stats.site.heatmapLegend': 'Čím tmavší, tím blíž kapacitě brány. Červeně: víc aut, než brána za hodinu odbaví. Kapacity jsou orientační, potvrdí je závod.',
  'stats.site.gate.CLS': 'CLS (sila)',
  'stats.site.gate.PST': 'PST (palety)',
  'stats.site.dwellTitle': 'Doba v areálu',
  'stats.site.dwellHint': 'Medián za vybrané období; 90 % aut je hotových do uvedené doby',
  'stats.site.silo': 'Sila',
  'stats.site.pallet': 'Palety',
  'stats.site.p90': '90 % do',
  'stats.site.dwellMinutes': 'V areálu celkem (brána → odjezd)',
  'stats.site.waitMinutes': 'Čekání před nakládkou',
  'stats.site.loadMinutes': 'Nakládka',
  'stats.last30': '30 dní',
  'stats.last90': '90 dní',
  'stats.beforePilot': 'před pilotem',
  'stats.pilotStart': 'Start pilotu',
  'stats.unit.perDay': '/ den',
  'stats.unit.trucksPerNight': 'aut / noc',
  'stats.kpi.noShows': 'Nepřijetí bez avíza',
  'stats.kpi.informed': 'Nakládky s informací ve 13:00',
  'stats.kpi.urgencies': 'Urgence dopravců',
  'stats.kpi.autoResolved': 'vyřešeno automaticky',
  'stats.kpi.parking': 'Parkoviště Jeseník',
  'stats.chart.noShows': 'Nepřijetí bez avíza po dnech',
  'stats.chart.noShowsHint': 'Auta, která nepřijela a nedala vědět. Před pilotem 10–15 denně (dle klienta).',
  'stats.chart.informed': 'Nakládky s informací ve 13:00',
  'stats.chart.informedHint': 'Podíl dnešních nakládek, o kterých ve 13:00 víme, jestli a kdy přijedou.',
  'stats.chart.urgencies': 'Urgence: vyřešeno automaticky vs. plánovačem',
  'stats.chart.urgenciesHint': 'Před pilotem urgoval plánovač ručně a nikdo to neevidoval.',
  'stats.chart.parking': 'Auta na parkovišti Jeseník za noc',
  'stats.chart.parkingHint': 'Méně aut bez výkonu a bez avíza znamená menší potřebu záchytného parkoviště.',
  'stats.series.auto': 'Automaticky',
  'stats.series.planner': 'Plánovač',
  'stats.tab.urgency': 'Urgence',
  'stats.urgency.period': 'Pilotní dny v období: {days}, urgencí celkem: {total}',
  'stats.urgency.replyPct': 'Míra odpovědí',
  'stats.urgency.replyMedian': 'Medián odpovědi',
  'stats.urgency.escalated': 'Eskalace na hovor',
  'stats.urgency.escalatedHint': 'Bez odpovědi do 30 min',
  'stats.urgency.resolution': 'Automaticky / plánovač',
  'stats.urgency.resolutionHint': 'Vyřešeno samo vs. předáno plánovači',
  'stats.urgency.byChannel': 'Urgence podle kanálu',
  'stats.urgency.channel': 'Kanál',
  'stats.urgency.sent': 'Odesláno',
  'stats.urgency.cost': 'Náklady',
  'stats.urgency.czk': 'Kč',
  'stats.urgency.channelLegend': 'První zpráva jde kanálem, který dopravce používá. Bez odpovědi do 30 minut následuje hlasový hovor, potom plánovač. Doba odpovědi u hovoru se měří od vytočení.',
  'stats.urgency.savingsTitle': 'Odhad úspory za měsíc',
  'stats.urgency.hoursPerMonth': 'h / měsíc',
  'stats.urgency.savedHours': 'Ušetřený čas plánovače: urgence, které už nemusí řešit ručně',
  'stats.urgency.czkPerMonth': 'Kč / měsíc',
  'stats.urgency.channelCost': 'Náklady na zprávy a hovory',
  'stats.urgency.assumption': 'Předpoklad: ruční urgence zabere plánovači {minutes} min (dohledat kontakt, zavolat, zapsat výsledek), měsíc má {days} pracovních dní. Ceny za zprávu nebo hovor: {prices}. Demo data, ceny orientační.',
  'nav.views': 'Pohledy stránky',
  'ai.live': 'AI',
  'ai.demo': 'AI demo',
  'ai.liveHint': 'Odpověď od Claude (AI).',
  'ai.demoHint': 'Připravená ukázková odpověď: AI klíč zatím není nastavený nebo AI neodpověděla.',
  'stats.value.title': 'Hodnota pilotu pro závod',
  'stats.value.month': 'měsíc',
  'stats.value.roi': 'Návratnost {roi}× při ceně {price} měsíčně',
  'stats.value.parking': 'Parkoviště Jeseník',
  'stats.value.parkingCalc': 'aut za noc {before} → {now} (−{pct} %) z {cost} Kč měsíčně',
  'stats.value.noShows': 'Méně nepřijetí bez avíza',
  'stats.value.noShowsCalc': '{count} nepřijetí měsíčně méně × {cost} Kč',
  'stats.value.planner': 'Čas plánovače',
  'stats.value.plannerCalc': '{hours} h × {cost} Kč',
  'stats.value.messages': 'Náklady na zprávy a hovory',
  'stats.value.messagesCalc': 'SMS, WhatsApp, e-mail, hlasové hovory',
  'stats.value.source.client': 'číslo od klienta',
  'stats.value.source.estimate': 'náš odhad',
  'stats.value.noShowCostInput': 'Cena jednoho nepřijetí',
  'stats.value.priceInput': 'Cena softwaru měsíčně',
  'stats.value.note': 'Náklady na parkoviště a cenu nepřijetí upřesníme podle čísel OMYA.',
  'ai.energy.title': 'Doporučený plán mletí na zítra',
  'ai.energy.hint': 'AI rozvrhne mlýny do nejlevnějších hodin podle cen OTE. Náklady a úsporu počítá aplikace.',
  'ai.energy.recommend': 'Doporučit plán (AI)',
  'ai.energy.habit': 'Dnes (start v 6:00)',
  'ai.energy.plan': 'Podle doporučení',
  'ai.energy.saving': 'Úspora za den',
  'ai.energy.legend': 'Barva = cenové pásmo (zelená levné, červená špička), obrys = dnešní zvyk. Ceny: modelový pracovní den OTE.',
  'ai.doc.title': 'Doklad z fotky',
  'ai.doc.upload': 'Vyfotit nebo nahrát doklad',
  'ai.doc.expected': 'čekáno',
  'ai.doc.attach': 'Uložit k nakládce',
  'ai.doc.attached': 'Uloženo do komunikace.',
  'ai.doc.tooLarge': 'Soubor je větší než 4,8 MB.',
  'ai.doc.allMatch': 'vše sedí s nakládkou',
  'ai.doc.type.cmr': 'CMR',
  'ai.doc.type.weighbridge': 'Vážní lístek',
  'ai.doc.type.delivery-note': 'Dodací list',
  'ai.doc.type.other': 'Jiný doklad',
  'ai.doc.field.plate': 'SPZ',
  'ai.doc.field.orderId': 'Dodávka',
  'ai.doc.field.weight': 'Hmotnost',
  'ai.voice.call': 'Zavolat AI hlasem:',
  'ai.voice.ringing': 'Vytáčím…',
  'ai.voice.inProgress': 'Hovor probíhá',
  'ai.voice.ended': 'Hovor ukončen',
  'ai.voice.simulation': 'Simulace hovoru',
  'ai.voice.result': 'Výsledek',
  'ai.voice.noAnswer': 'Dispečer nezvedá, nakládka jde plánovači.',
  'ai.assistant.title': 'Asistent AI',
  'ai.assistant.ask': 'Zeptat se asistenta',
  'ai.assistant.thinking': 'Přemýšlím…',
  'ai.assistant.back': 'Zpět na hledání',
  'ai.brief.prepare': 'Připravit podklady k jednání (AI)',
  'ai.brief.title': 'Podklady k jednání s dopravcem',
  'ai.brief.goal': 'Cíl',
  'ai.brief.arguments': 'Argumenty',
  'ai.brief.proposals': 'Návrh podmínek',
  'ai.brief.agreements': 'Na čem se dohodnout',
  'ai.brief.note': 'Návrh od AI z čísel měsíce. Před jednáním zkontrolujte a upravte.',
  'ai.replan.propose': 'Navrhnout řešení (AI)',
  'ai.replan.title': 'Návrh přeplánování',
  'ai.replan.risk': 'Riziko',
  'ai.replan.accept': 'Přijmout',
  'ai.replan.reject': 'Zamítnout',
  'ai.replan.accepted': 'Přijato: nakládka je přeplánovaná, zápis je v komunikaci.',
  'ai.replan.rejected': 'Zamítnuto, plán zůstává beze změny.',
  'ai.comment.title': 'Komentář AI',
  'ai.comment.loading': 'Píšu komentář…',
  'ai.ask.title': 'Zeptejte se statistik',
  'ai.ask.placeholder': 'Např. Který dopravce nejčastěji nepřijede bez avíza?',
  'ai.ask.send': 'Zeptat se',
  'ai.ask.source': 'Zdroj',
  'ai.ask.q1': 'Kolik aut nepřijede bez avíza a jak to bylo před pilotem?',
  'ai.ask.q2': 'Který dopravce je nejproblémovější?',
  'ai.ask.q3': 'Kolik času ušetřila automatická urgence?',
  'ai.ask.q4': 'Jak se vyvíjí informovanost ve 13:00?',
  'ai.reply.title': 'Simulovat odpověď dopravce',
  'ai.reply.placeholder': 'Napište odpověď dopravce, třeba polsky…',
  'ai.reply.read': 'Rozpoznat odpověď',
  'ai.reply.unclear': 'Nejasné',
  'ai.reply.confidence': 'Jistota',
  'ai.reply.reason': 'Důvod',
  'ai.reply.noTranslation': 'Překlad dělá jen AI s klíčem.',
  'ai.reply.applied': 'Nastaveno automaticky, odpověď je v komunikaci.',
  'ai.reply.confirm': 'Potvrdit',
  'ai.reply.dismiss': 'Zahodit',
  'ai.reply.readByAi': 'rozpoznáno AI',
  'nav.focus': 'TEĎ ŘEŠÍME',
  'nav.concepts': 'MOŽNOSTI / KONCEPTY',
  'nav.conceptsHint': 'Nápady do budoucna, zatím bez reálných dat',
  'concept.badge': 'Koncept',
  'concept.hint': 'Ukázka možného rozšíření. Data jsou ilustrativní a modul zatím není v plánu pilotu.',
  'nav.branchDetection': 'Detekce větví',
  'nav.visualFactory': 'Visual Factory',

  // ── Detekce větví ──
  'branchDetection.title': 'Detekce větví',
  'branchDetection.description': 'AI modul pro detekci větví v dopravníku. Identifikuje nežádoucí kontaminaci v kameni v reálném čase.',
  'branchDetection.demo': 'Ukázka detekce',
  'branchDetection.detected': 'Detekováno',
  'branchDetection.branches': 'větve',
  'branchDetection.accuracy': 'Přesnost',
  'branchDetection.zone': 'Detekční zóna',
  'branchDetection.live': 'Živě',
  'branchDetection.label': 'větev',
  'branchDetection.shift.title': 'Ranní směna: nálezy na pásu',
  'branchDetection.shift.total': 'Nálezy',
  'branchDetection.shift.perHour': 'Nálezy po hodinách',
  'branchDetection.shift.note': 'Ukázka konceptu na ilustračních datech. Skutečná verze potřebuje kameru nad pásem a natrénovaný obrazový model.',
  'branchDetection.outcome.ejected': 'Vyřazeno klapkou',
  'branchDetection.outcome.review': 'Ke kontrole',
  'branchDetection.outcome.false': 'Planý poplach',

  // ── Header ──
  'header.search': 'Hledat',
  'header.notifications': 'Oznámení',
  'header.activeAlerts': 'aktivních upozornění',
  'header.markAllRead': 'Označit vše',
  'header.allClear': 'Vše v pořádku',
  'header.live': 'ŽIVĚ',
  'header.profile': 'Profil',
  'header.settings': 'Nastavení',
  'header.signOut': 'Odhlásit se',
  'header.justNow': 'právě teď',
  'header.minAgo': 'min zpět',
  'header.hrAgo': 'hod zpět',
  'header.dAgo': 'd zpět',
  'header.language': 'Jazyk',

  // ── Command Palette ──
  'cmd.placeholder': 'Hledat objednávky, kamiony, uzly...',
  'cmd.noResults': 'Žádné výsledky.',
  'cmd.pages': 'Stránky',
  'cmd.orders': 'Objednávky',
  'cmd.trucks': 'Kamiony',
  'cmd.supplyChainNodes': 'Uzly výrobního řetězce',
  'cmd.util': 'využití',

  // ── Dashboard ──
  'dashboard.title': 'Přehled',
  'dashboard.plant': 'Závod Pomezí',
  'dashboard.totalOutputToday': 'Celkový výstup dnes',
  'dashboard.morningShift': 'Ranní směna',
  'dashboard.afternoonShift': 'Odpolední směna',
  'dashboard.nightShift': 'Noční směna',
  'dashboard.all': 'Vše',
  'dashboard.am': 'Ráno',
  'dashboard.pm': 'Odpoledne',
  'dashboard.night': 'Noc',
  'dashboard.operationsActive': 'Provoz aktivní',
  'dashboard.linesInOperation': 'linky v provozu',
  'dashboard.loadings': 'nakládek',
  'dashboard.todaysOutput': 'Výstup dnes',
  'dashboard.vsYesterday': 'vs včera',
  'dashboard.plantUtilization': 'Vytížení závodu',
  'dashboard.linesActive': 'aktivní linky',
  'dashboard.oee': 'OEE',
  'dashboard.loadingsToday': 'Nakládky dnes',
  'dashboard.remaining': 'zbývá',
  'dashboard.qualityRate': 'Kvalita',
  'dashboard.energyCost': 'Náklady na energii',
  'dashboard.costPerTonne': 'Cena za tunu',
  'dashboard.costPerTonneSub': 'Živé OTE × spotřeba mletí',
  'dashboard.offPeakUntil': 'NÍZKÝ TARIF do 14:00',
  'dashboard.productionLast7Days': 'Výroba – posledních 7 dní',
  'dashboard.actual': 'Skutečnost',
  'dashboard.target': 'Cíl',
  'dashboard.lineUtilization': 'Vytížení linek',
  'dashboard.utilization': 'Vytížení',
  'dashboard.activeAlerts': 'Aktivní upozornění',
  'dashboard.oeeFull': 'OEE (Celková efektivita zařízení)',

  // ── KPI Card ──
  'kpi.target': 'Cíl',
  'kpi.offPeakUntil14': 'NÍZKÝ TARIF do 14:00',

  // ── KPI Drilldown ──
  'drilldown.title': 'Detail',
  'drilldown.todayHourly': 'Dnes (po hodinách)',
  'drilldown.thisWeek': 'Tento týden',
  'drilldown.thisMonth': 'Tento měsíc',
  'drilldown.peakHour': 'Špička',
  'drilldown.avgPerHour': 'Průměr/hod',
  'drilldown.total': 'Celkem',
  'drilldown.bestDay': 'Nejlepší den',
  'drilldown.weeklyAvg': 'Týdenní průměr',
  'drilldown.vsTarget': 'vs Cíl',
  'drilldown.monthTotal': 'Celkem za měsíc',
  'drilldown.week1': 'Týden 1',
  'drilldown.week2': 'Týden 2',
  'drilldown.week3': 'Týden 3',
  'drilldown.week4': 'Týden 4',

  // ── Alert Strip ──
  'alerts.allOperational': 'Všechny systémy v provozu — žádná aktivní upozornění',
  'alerts.showLess': 'Zobrazit méně',
  'alerts.showAll': 'Zobrazit vše',

  // ── Trucks Page ──
  'trucks.title': 'Příjezdy',
  'trucks.enRoute': 'Na cestě',
  'trucks.waiting': 'Čeká',
  'trucks.weighIn': 'Vážení-in',
  'trucks.loading': 'Nakládka',
  'trucks.weighOut': 'Vážení-out',
  'trucks.departed': 'Odjel',
  'trucks.total': 'Celkem',
  'trucks.loadingTimeline': 'Časová osa nakládek',
  'trucks.siteMap': "Areál teď",
  'trucks.siteLayout': 'Plán areálu',
  'trucks.plant': 'ZÁVOD',
  'trucks.omyaJesenik': 'OMYA Pomezí',
  'trucks.truckCount': 'kamionů',
  'trucks.weighBridge': 'VÁHA',
  'trucks.searchPlaceholder': 'Hledat kamiony...',

  // ── Truck Detail Sheet ──
  'truckDetail.overview': 'Přehled',
  'truckDetail.timeline': 'Časová osa',
  'truckDetail.order': 'Objednávka',
  'truckDetail.load': 'Náklad',
  'truckDetail.driver': 'Řidič',
  'truckDetail.currentLoad': 'Aktuální náklad',
  'truckDetail.loaded': 'naloženo',
  'truckDetail.remaining': 'zbývá',
  'truckDetail.progress': 'Průběh',
  'truckDetail.gate': 'Brána',
  'truckDetail.eta': 'Příjezd',
  'truckDetail.event': 'Událost',
  'truckDetail.linkedOrder': 'Propojená objednávka',
  'truckDetail.noLinkedOrder': 'Žádná propojená objednávka',
  'truckDetail.documents': 'Dokumenty',
  'truckDetail.material': 'Materiál',
  'truckDetail.targetWeight': 'Cílová hmotnost',
  'truckDetail.currentWeight': 'Aktuální hmotnost',
  'truckDetail.timestamps': 'Časové údaje',
  'truckDetail.arrived': 'Příjezd',
  'truckDetail.loadingStarted': 'Začátek nakládky',
  'truckDetail.loadingTimeBySack': 'Doba nakládky / typ balení',

  // ── Planning Page ──
  'planning.title': 'Plánování',
  'planning.week': 'Týden',
  'planning.thisWeek': 'Tento týden',
  'planning.weekView': 'Týdenní pohled',
  'planning.ganttView': 'Ganttův pohled',
  'planning.capacity': 'Kapacita',
  'planning.scheduled': 'Naplánováno',
  'planning.available': 'Volné',
  'planning.materials': 'Materiály',
  'planning.weeklySummary': 'Týdenní souhrn',
  'planning.plannedOutput': 'Plánovaný výstup',
  'planning.actualOutput': 'Skutečný výstup',
  'planning.completion': 'Dokončení',
  'planning.avgUtilization': 'Průměrné vytížení',
  'planning.energyTariffs': 'Energetické tarify',
  'planning.off': 'NÍZKÝ',
  'planning.peak': 'ŠPIČKA',
  'planning.tariffStandard': 'STŘED',
  'planning.tariffNegative': 'ZÁPOR',
  'planning.schedule': '+ Plánovat',
  'addPlanning.title': 'Přidat plánování',
  'addPlanning.material': 'Materiál',
  'addPlanning.order': 'Objednávka',
  'addPlanning.selectOrder': 'Vyberte objednávku',
  'addPlanning.noOrder': 'Bez objednávky',
  'addPlanning.energyTariff': 'Energetický tarif',
  'addPlanning.tariff': 'tarif',
  'addPlanning.cancel': 'Zrušit',
  'addPlanning.add': 'Přidat',
  'planning.now': 'Nyní',
  'planning.material.gcc': 'Vápenec GCC',
  'planning.material.pcc': 'Vápenec PCC',
  'planning.material.byproduct': 'Vedlejší produkt',
  'planning.productionFlow': 'Výrobní tok',
  'planning.productionFlowDesc': 'Kámen (surovina) → vápencové produkty (GCC/PCC) → vedlejší produkt (CaCO3). Při zpracování kamene vznikají hlavní výstupy i vedlejší produkt.',
  'planning.mainProduction': 'Hlavní výroba',
  'planning.byProduct': 'Vedlejší produkt',
  'planning.fraction': 'Frakce',
  'planning.fraction.sand': 'Písek',
  'planning.fraction.fine': 'Jemná',
  'planning.fraction.standard': 'Standard',
  'planning.fraction.powder': 'Pudr',
  'planning.fractionCycleNote': 'doba cyklu na tunu',
  'planning.packagingLine': 'Balicí linka',
  'planning.packaging.bigBag': 'Big bag (1 t)',
  'planning.packaging.bag25': 'Pytle 25 kg',
  'planning.packaging.bag50': 'Pytle 50 kg',
  'planning.packaging.bulk': 'Volně ložené (silo)',
  'planning.linkedTo': 'Vázáno na',
  'planning.linkedDeps': 'Provázaná výroba',
  'planning.linkedDepsDesc': 'Výroba tohoto materiálu vyžaduje paralelní výrobu uvedených položek.',
  'gantt.util': 'vytíž.',
  'gantt.planned': 'plánováno',

  // ── Days of week ──
  'day.mon': 'Po',
  'day.tue': 'Út',
  'day.wed': 'St',
  'day.thu': 'Čt',
  'day.fri': 'Pá',
  'day.sat': 'So',
  'day.sun': 'Ne',

  // ── Orders Page ──
  'orders.title': 'Objednávky',
  'orders.totalOrders': 'Celkem objednávek',
  'orders.totalValue': 'Celková hodnota',
  'orders.avgOrder': 'Průměrná objednávka',
  'orders.fulfillmentRate': 'Míra plnění',
  'orders.allStatuses': 'Všechny stavy',
  'orders.pending': 'Čeká',
  'orders.confirmed': 'Potvrzeno',
  'orders.inProduction': 'Ve výrobě',
  'orders.produced': 'Vyrobeno',
  'orders.dispatched': 'Expedováno',
  'orders.delivered': 'Doručeno',
  'orders.searchPlaceholder': 'Hledat podle objednávky, zákazníka nebo materiálu...',
  'orders.status': 'Stav',
  'orders.number': '#',
  'orders.customer': 'Zákazník',
  'orders.items': 'Položky',
  'orders.progress': 'Průběh',
  'orders.value': 'Hodnota',
  'orders.delivery': 'Dodání',
  'orders.showing': 'Zobrazeno',
  'orders.of': 'z',
  'orders.ordersCount': 'objednávek',

  // ── Supply Chain ──
  'supplyChain.title': 'Výrobní řetězec',
  'supplyChain.addWidget': 'Přidat widget',
  'supplyChain.widgetAdded': 'Widget přidán',
  'supplyChain.widgetRemoved': 'Widget odebrán',
  'supplyChain.node.quarry': 'Lom',
  'supplyChain.node.crusher': 'Drtič',
  'supplyChain.node.sorting': 'Třídění',
  'supplyChain.node.packaging': 'Balení',
  'supplyChain.node.bulk': 'Sypké',
  'supplyChain.node.dispatch': 'Expedice',
  'supplyChain.node.silo': 'Silo',
  'supplyChain.crusherTariffBadge': 'Drtič – aktuální tarif',
  'supplyChain.crusherCostNow': 'Cena za tunu (teď)',
  'supplyChain.siloFillTime': 'doba plnění',
  'supplyChain.siloCapacity': 'kapacita',
  'supplyChain.siloContent': 'obsah',
  'supplyChain.bottleneck': 'Úzké místo',
  'supplyChain.legend': 'Legenda',
  'supplyChain.legend.nodeStatus': 'Stav uzlu',
  'supplyChain.legend.operational': 'V provozu',
  'supplyChain.legend.warning': 'Varování',
  'supplyChain.legend.errorBottleneck': 'Chyba / Úzké místo',
  'supplyChain.legend.flowStatus': 'Stav toku',
  'supplyChain.legend.activeFlow': 'Aktivní tok',
  'supplyChain.legend.reducedFlow': 'Snížený tok',
  'supplyChain.legend.stopped': 'Zastaveno',
  'supplyChain.legend.capacity': 'Kapacita',
  'supplyChain.legend.capacityUnder60': '< 60 %',
  'supplyChain.legend.capacity60to85': '60–85 %',
  'supplyChain.legend.capacityOver85': '> 85 %',
  'supplyChain.status.operational': 'V provozu',
  'supplyChain.status.warning': 'Varování',
  'supplyChain.status.error': 'Chyba',

  // ── SAP Integration ──
  'sap.title': 'SAP Integrace',
  'sap.heading': 'Integrace SAP S/4HANA',
  'sap.subtitle': 'Obousměrná synchronizace dat',
  'sap.omyaDigitalPlant': 'OMYA Digitální závod',
  'sap.supplyChainTrucks': 'Výrobní řetězec · Kamiony',
  'sap.planningOrders': 'Plánování · Objednávky',
  'sap.restApi': 'REST API',
  'sap.middleware': 'Middleware',
  'sap.dataMapping': 'Mapování dat',
  'sap.validationAuth': 'Validace · Ověření',
  'sap.rfcOdata': 'RFC / OData',
  'sap.dataFlows': 'Datové toky',
  'sap.syncStatus': 'Stav synchronizace',
  'sap.apiLog': 'API Log',
  'sap.dataType': 'Typ dat',
  'sap.direction': 'Směr',
  'sap.frequency': 'Frekvence',
  'sap.lastSync': 'Poslední sync',
  'sap.status': 'Stav',
  'sap.productionOrders': 'Výrobní příkazy',
  'sap.inventoryLevels': 'Stav zásob',
  'sap.customerMaster': 'Zákaznická data',
  'sap.dispatchConfirmations': 'Potvrzení expedice',
  'sap.loadingPlans': 'Plány nakládek',
  'sap.qualityResults': 'Výsledky kvality',
  'sap.materialSpecs': 'Specifikace materiálu',
  'sap.financialData': 'Finanční data',
  'sap.realTime': 'V reálném čase',
  'sap.every5Min': 'Každých 5 min',
  'sap.daily': 'Denně',
  'sap.onEvent': 'Při události',
  'sap.every15Min': 'Každých 15 min',
  'sap.weekly': 'Týdně',
  'sap.ppProduction': 'PP (Výroba)',
  'sap.mmMaterials': 'MM (Materiály)',
  'sap.sdSales': 'SD (Prodej)',
  'sap.qmQuality': 'QM (Kvalita)',
  'sap.pmMaintenance': 'PM (Údržba)',
  'sap.fiFinance': 'FI (Finance)',
  'sap.recordsSynced': 'záznamů synchronizováno',
  'sap.synchronized': 'Synchronizováno',
  'sap.delayed': 'Zpožděno',
  'sap.time': 'Čas',
  'sap.method': 'Metoda',
  'sap.endpoint': 'Endpoint',
  'sap.duration': 'Doba trvání',
  'sap.infoTitle': 'Vizuální mockup.',
  'sap.infoText': 'Neprobíhá žádný přenos dat. Plná integrace SAP S/4HANA plánována na Q3 2026 včetně zabezpečeného API, SSO ověření, auditního logování a synchronizace v reálném čase.',

  // ── Login ──
  'login.welcomeBack': 'Vítejte zpět',
  'login.signInSubtitle': 'Přihlaste se pro přístup k přehledu',
  'login.email': 'E-mail',
  'login.emailPlaceholder': 'jmeno.prijmeni@omya.com',
  'login.password': 'Heslo',
  'login.forgot': 'Zapomněli jste?',
  'login.passwordPlaceholder': 'Zadejte heslo',
  'login.signIn': 'Přihlásit se',
  'login.signingIn': 'Přihlašování...',
  'login.demoMode': 'Demo režim — přijímány jakékoli přihlašovací údaje',

  // ── Production Order Dialog ──
  'prodDialog.utilization': 'Vytížení',
  'prodDialog.planned': 'Plánováno',
  'prodDialog.actual': 'Skutečnost',
  'prodDialog.productionProgress': 'Průběh výroby',
  'prodDialog.offPeak': 'NÍZKÝ TARIF',
  'prodDialog.peak': 'ŠPIČKA',
  'prodDialog.shift': 'směna',
  'prodDialog.hourlyOutput': 'Hodinový výstup',
  'prodDialog.order': 'Objednávka',

  // ── Gantt View ──
  'gantt.now': 'Nyní',

  // ── Shift labels ──
  'shift.morning': 'Ranní',
  'shift.afternoon': 'Odpolední',
  'shift.night': 'Noční',

  // ── Add Widget Dialog ──
  'widget.addTitle': 'Přidat widget metriky',
  'widget.addDescription': 'Vyberte uzel a metriku pro zobrazení na plátně.',
  'widget.sourceNode': 'Zdrojový uzel',
  'widget.selectNode': 'Vyberte uzel...',
  'widget.metric': 'Metrika',
  'widget.selectMetric': 'Vyberte metriku...',
  'widget.cancel': 'Zrušit',
  'widget.add': 'Přidat widget',
  'metric.oeeOverall': 'OEE celkem',
  'metric.availability': 'Dostupnost',
  'metric.performance': 'Výkon',
  'metric.quality': 'Kvalita',
  'metric.utilization': 'Vytížení',
  'metric.currentOutput': 'Aktuální výstup',
  'metric.maxCapacity': 'Max. kapacita',
  'metric.activeAlerts': 'Aktivní upozornění',
  'metric.hoursRun': 'Odpracované hodiny',

  // ── OEE Overlay ──
  'oee.plantOee': 'OEE závodu',
  'oee.availability': 'Dostupnost',
  'oee.performance': 'Výkon',
  'oee.quality': 'Kvalita',
  'oee.throughput': 'Průtok',

  // ── Node Detail Panel ──
  'node.currentOutput': 'Aktuální výstup',
  'node.oeeBreakdown': 'Rozklad OEE',
  'node.availability': 'Dostupnost',
  'node.performance': 'Výkon',
  'node.quality': 'Kvalita',
  'node.overall': 'Celkem',
  'node.material': 'Materiál',
  'node.order': 'Objednávka',
  'node.progress': 'Průběh',
  'node.throughput': 'Průtok',
  'node.uptime': 'Provozuschopnost',
  'node.qualityRate': 'Míra kvality',
  'node.utilization': 'Vytížení',
  'node.performanceRadar': 'Radar výkonu',
  'node.speed': 'Rychlost',
  'node.energy': 'Energie',
  'node.output': 'Výstup',
  'node.actual': 'Skutečnost',
  'node.target': 'Cíl',

  // ── Orders filter ──
  'orders.statusFilter': 'Stav',

  // ── Visual Factory ──
  'visualFactory.title': 'Visual Factory',
  'visualFactory.panel.capacity': 'Kapacita a vytížení',
  'visualFactory.panel.orders': 'Dnešní objednávky',
  'visualFactory.panel.trucks': 'Kamiony právě teď',
  'visualFactory.panel.ote': 'Energetický tarif',
  'visualFactory.now': 'TEĎ',
  'visualFactory.utilized': 'Vytíženo',
  'visualFactory.free': 'Volno',
  'visualFactory.alerts': 'Upozornění',
  'visualFactory.shift': 'Směna',
  'visualFactory.costPerTonne': 'Cena / tuna',
  'visualFactory.exitFullscreen': 'Ukončit fullscreen',
  'visualFactory.todayProduced': 'Vyrobeno dnes',
  'visualFactory.expected': 'Měli bychom být',
  'visualFactory.shiftRemaining': 'Zbývá směně',
  'visualFactory.productionLines': 'Výrobní linky',
  'visualFactory.silosAndTrucks': 'Sila a kamiony',
  'visualFactory.target': 'cíl',
  'visualFactory.fullIn': 'Plné za',
  'visualFactory.truckEta': 'Auto',
  'visualFactory.collision': 'Kolize',
  'visualFactory.collisionLegend': 'Červená = silo plné dřív než auto',
  'visualFactory.noTruck': 'Žádné auto v plánu',
  'visualFactory.expeditionToday': 'Expedice dnes',
  'visualFactory.trucksOnSite': 'Aut v areálu',
  'visualFactory.waitingOver30': 'čekají > 30 min',
  'visualFactory.maintenance': 'Údržba',
  'visualFactory.daysSinceIncident': 'Dní bez úrazu',
  'visualFactory.tickerPeak': 'Doporučeno omezit mletí jemných frakcí, naplánovat na offpeak',
  'visualFactory.tickerNegative': 'Záporná cena — vhodný čas na energožravé operace',
  'visualFactory.tickerOffPeak': 'Levný tarif — vhodný čas na mletí pudru a jemných frakcí',
  'visualFactory.tickerStandard': 'Standardní tarif',
  'visualFactory.backToApp': 'Zpět do aplikace',
  'visualFactory.whatIsThis': 'Co tady vidím?',
  'visualFactory.bannerHint': 'Černá linka = kde bychom měli být právě teď. Bílý sloupec = co jsme vyrobili.',
  'visualFactory.linesHint': 'Stav 3 výrobních linek. Zelená = běží na cíli, žlutá = pomalý běh, červená = zastavená.',
  'visualFactory.silosHint': 'Plnost sil + ETA aut. Červený rámeček = silo bude plné dřív než dorazí auto (výroba se zastaví).',
  'visualFactory.tariffTicker': 'Energetický tarif (spodní řádek)',
  'visualFactory.footerInfo': 'Spodní lišta — expedice, údržba, bezpečnost',
  'visualFactory.aboutIntro': 'Tato obrazovka je určená na TV v hale závodu. Bez přihlášení, kdokoliv vidí stav výroby na jeden pohled. Obnovuje se každých 30 sekund.',
  'visualFactory.aboutBanner': 'Velký banner nahoře. Vyrobená tonáž dnes vs denní plán, plus odhad zbývajícího času směny. Černá svislá linka označuje hodnotu, na které bychom měli být právě teď (kdyby vše šlo podle plánu).',
  'visualFactory.aboutLines': 'Tři dlaždice — jedna na výrobní linku. Barevná dioda ukazuje stav (zelená/žlutá/červená dle ISA-101). Pokud linka jede pomalu nebo stojí, dlaždice ukáže důvod a stopky odkdy.',
  'visualFactory.aboutSilos': 'Hlavní část obrazovky. Pro každé silo: aktuální plnost, výpočet kdy bude plné při současném tempu výroby, a ETA nejbližšího kamionu. Červený rámeček = kolize: silo přeteče dřív než kamion dorazí → musí se okamžitě volat dispečer dopravy.',
  'visualFactory.aboutFooter': 'Expedice dnes (CZ/PL split), počet kamionů v areálu (a kolik z nich čeká přes 30 minut), aktivní údržba s ETA, dni bez úrazu.',
  'visualFactory.aboutTicker': 'Aktuální OTE energetický tarif + doporučení pro plánování výroby (peak = omezit jemné frakce, off-peak/negative = vhodný čas).',
  'visualFactory.aboutFooterNote': 'Žádné citlivé údaje (jména řidičů, marže, polské zákazníky). Obrazovka je veřejná v rámci závodu.',

  // ── Status (utils.js) ──
  'status.ok': 'OK',
  'status.warning': 'Varování',
  'status.problem': 'Problém',

  // ── Dashboard additions ──
  'dash.arrivals.title': 'Příjezdy dnes',
  'dash.arrivals.urgency': 'Urgence dopravců ve 13:00',
  'dash.arrivals.open': 'Otevřít příjezdy',
  'dash.arrivals.informed': 'S informací',
  'dash.parking.title': 'Parkoviště Jeseník',
  'dash.parking.month': 'měsíc',
  'dash.parking.source': 'Náklad dle klienta (odhad)',
  'dash.parking.goal': 'Cíl: utlumit parkoviště díky avizovaným příjezdům.',
  'dash.mobileWarning': 'Pozor — Aplikace je optimalizovaná pro PC. Na telefonu nemusí fungovat 100%.',
  'dash.productionScorecard': 'Hodnocení výroby',
  'dash.productionScorecardDesc': 'Modul vyhodnocuje stav výroby — implementace externím dodavatelem',

  // ── Trucks ──
  'trucks.weighBridgeLabel': 'Váha',
  'trucks.wbActive': 'Aktivní',
  'trucks.wbIdle': 'Nečinná',
  'trucks.wbLast': 'Poslední',
  'trucks.loadingSlots': 'Okna nakládek',
  'trucks.addSlot': 'Přidat slot',
  'trucks.slotFree': 'Volné',
  'trucks.qr.dontComeNow': 'Teď nejezděte',
  'trucks.qr.youCanComeSlotFree': 'Můžete jet, slot je volný',
  'trucks.qr.delay30': 'Odložte příjezd o 30 min',
  'trucks.qr.goToWeighbridge': 'Zajeďte na váhu',
  'trucks.qr.waitAtGate': 'Čekejte u brány',
  'trucks.dm.hourAway': 'Jsem hodinu od vás',
  'trucks.dm.in45': 'Přijedu za 45 min',
  'trucks.dm.atGate': 'Jsem u brány',
  'trucks.dm.loadingDone': 'Nakládka hotová?',
  'trucks.dm.thanksDriving': 'Děkuji, jedu',
  'trucks.toast.messageSent': 'Zpráva odeslána (demo)',
  'trucks.noMessagesYet': 'Zatím žádné zprávy',
  'trucks.typeMessage': 'Napište zprávu...',
  'trucks.simulateDriverMessage': 'Simulovat zprávu od řidiče',
  'truckDetail.communication': 'Komunikace',
  'truckDetail.calling': 'Volám',

  // ── Orders / Layout / Header ──
  'layout.digitalPlant': 'DIGITÁLNÍ ZÁVOD',
  'header.markAllReadToast': 'Všechna oznámení označena jako přečtená',
  'orders.actionSimulated': 'Akce simulována — demo režim',
  'orders.confirm': 'Potvrdit',
  'orders.dispatch': 'Expedovat',
  'orders.invoice': 'Faktura',
  'orders.tab.overview': 'Přehled',
  'orders.tab.items': 'Položky',
  'orders.tab.timeline': 'Časová osa',
  'orders.tab.delivery': 'Dodání',
  'orders.ico': 'IČO',
  'orders.createdAt': 'Vytvořeno',
  'orders.confirmedAt': 'Potvrzeno',
  'orders.material': 'Materiál',
  'orders.quantity': 'Množství',
  'orders.pricePerTon': 'Cena/t',
  'orders.total': 'Celkem',
  'orders.productionProgress': 'Průběh výroby',
  'orders.linkedTrucks': 'Propojené kamiony',
  'orders.noTrucks': 'Žádné kamiony',
  'orders.certificates': 'Certifikáty',
  'orders.noCertificates': 'Zatím žádné certifikáty',

  // ── Planning ──
  'plan.howItWorks': 'Jak funguje plánování?',
  'plan.howItWorksDesc': 'Modul plánování optimalizuje výrobu na základě vstupních dat a generuje plán pro všechny výrobní linky.',
  'plan.input': 'Vstup',
  'plan.inputOrders': 'Objednávky a požadované materiály',
  'plan.inputCapacities': 'Kapacity výrobních linek',
  'plan.inputAvailability': 'Dostupnost materiálů a surovin',
  'plan.inputTariffs': 'Energetické tarify (špička / nízký tarif)',
  'plan.output': 'Výstup',
  'plan.outputWeeklyPlan': 'Týdenní plán výroby (tabulka / Gantt)',
  'plan.outputAssignment': 'Přiřazení materiálů na linky a směny',
  'plan.outputTariffOpt': 'Optimalizace dle energetických tarifů',
  'plan.outputTonnes': 'Plánovaný a skutečný výstup v tunách',
  'plan.oteOverlay': 'OTE vrstva',
  'plan.oteOverlayToggle': 'Přepnout OTE energetickou vrstvu',
  'plan.oteSpotNote': 'OTE spot, CZK/MWh, bez DPH a distribuce',
  'plan.oteSpotDaily': 'OTE spot — denní křivka',
  'plan.oteRecord': 'Rekord 5/2024',
  'plan.oteTypical': 'Typický den',
  'plan.min': 'Min',
  'plan.avg': 'Průměr',
  'plan.max': 'Max',
  'plan.inNegative': 'v záporu',
  'plan.negativeRecordSource': '• minimum −138,75 EUR/MWh • zdroj OTE a.s.',
  'plan.czkPerMWh': 'CZK/MWh',
  'plan.annualSavingsPotential': 'Roční potenciál úspory',
  'plan.savingsAssumption': 'Přesunutí 50 % špičkového mletí do offpeak/negative pásma OTE.',
  'plan.czkPerYear': 'CZK/rok',
  'plan.czkPerWeek': 'CZK/týden',
  'plan.pctOfPowerBill': '% účtu za elektřinu',
  'plan.specificEnergy': 'Měrná spotřeba mletí',
  'plan.peakTonnageWeek': 'Špičková tonáž (týden)',
  'plan.baselineNoOpt': 'Baseline (bez optimalizace)',
  'plan.czk': 'CZK',
  'plan.assumptionsTuning': 'Předpoklady ladíme s Petrovou skutečnou spotřebou.',

  // ── Node detail panel ──
  'node.tab.overview': 'Přehled',
  'node.tab.production': 'Výroba',
  'node.tab.maintenance': 'Údržba',
  'node.tab.connections': 'Vazby',
  'node.currentBatch': 'Aktuální dávka',
  'node.output24h': 'Výstup 24h',
  'node.weeklyOutputVsTarget': 'Týdenní výstup vs Target',
  'node.equipment': 'Zařízení',
  'node.manufacturer': 'Výrobce',
  'node.model': 'Model',
  'node.installed': 'Instalace',
  'node.operatingHours': 'Provozní hodiny',
  'node.nextMaintenance': 'Další údržba',
  'node.days': 'dní',
  'node.maintenanceHistory': 'Historie údržby',
  'node.date': 'Datum',
  'node.type': 'Typ',
  'node.description': 'Popis',
  'node.duration': 'Doba trvání',
  'node.unplanned': 'Neplánovaná',
  'node.scheduled': 'Plánovaná',
  'node.alerts': 'Upozornění',
  'node.linkedOrders': 'Propojené objednávky',
  'node.noLinkedOrders': 'Žádné propojené objednávky',
  'node.linkedTrucks': 'Propojené kamiony',
  'node.noLinkedTrucks': 'Žádné kamiony na tomto uzlu',

  // ── Mock data (dynamic content used in alerts, timelines, line labels) ──
  'mock.line1': 'Linka 1',
  'mock.line2': 'Linka 2',
  'mock.line3': 'Linka 3',
  'mock.alert.line2Overload': 'Linka 2 – Přetížení (92 %)',
  'mock.alert.noInfoLoadings': 'Nakládky bez informace – urgence dopravců ve 13:00',
  'mock.alert.pstQueue': 'Brána PST – 3 kamiony čekají',
  'mock.alert.dispatchOk': 'Expedice – v pořádku',
  'mock.alert.crusherBearingTemp': 'Teplota ložiska drtiče stoupá',
  'mock.alert.tariffPeakSwitch': 'Přepnutí tarifu na ŠPIČKU ve 14:00',
  'mock.alert.orderPending': 'Objednávka ORD-2024-1845 čeká na potvrzení',
  'mock.alert.truckEta45': 'Kamion 5L9 2341 příjezd za 45 min',
  'mock.line.stopReason.slowMillVibration': 'Pomalý mlýn — vibrace mimo prah',
  'mock.event.dispatch': 'Vyjíždí z depa',
  'mock.event.arriveGate': 'Příjezd k bráně',
  'mock.event.weighEmpty123': 'Vážení: 12,3 t (prázdný)',
  'mock.event.weighEmpty128': 'Vážení: 12,8 t (prázdný)',
  'mock.event.weighEmpty131': 'Vážení: 13,1 t (prázdný)',
  'mock.event.weigh125': 'Vážení: 12,5 t',
  'mock.event.weigh130': 'Vážení: 13,0 t',
  'mock.event.weighInProgress': 'Vážení probíhá',
  'mock.event.loadingStartedPST': 'Nakládka zahájena na PST',
  'mock.event.loadingStartedCLS': 'Nakládka zahájena na CLS',
  'mock.event.loadingStarted': 'Nakládka zahájena',
  'mock.event.weighOut365': 'Výjezdní vážení: 36,5 t',
  'mock.event.weighOut368': 'Výjezdní vážení: 36,8 t (naložený)',
  'mock.event.dispatched': 'Expedováno',
  'mock.event.arrived': 'Přijel',
  'mock.event.departed': 'Odjel',
  'mock.event.departedFacility': 'Odjel z areálu',
  'mock.event.waitingGate': 'Čeká na přiřazení brány',
  'mock.event.waitingSlot': 'Čeká na slot',
  'mock.note.received': 'Přijato',
  'mock.note.receivedEmail': 'Objednávka přijata e-mailem',
  'mock.note.receivedPhone': 'Přijato telefonicky',
  'mock.note.receivedPortal': 'Přijato přes portál',
  'mock.note.receivedOrderEmail': 'Objednávka přijata e-mailem',
  'mock.note.receivedOrderPortal': 'Objednávka přijata přes portál',
  'mock.note.receivedOrder': 'Objednávka přijata',
  'mock.note.confirmed': 'Potvrzeno',
  'mock.note.confirmedSales': 'Potvrzeno obchodem',
  'mock.note.confirmedSalesTeam': 'Potvrzeno obchodním týmem',
  'mock.note.started': 'Zahájeno',
  'mock.note.startedLine1': 'Zahájeno na Lince 1',
  'mock.note.startedLine2': 'Zahájeno na Lince 2',
  'mock.note.startedLine3': 'Zahájeno na Lince 3',
  'mock.note.productionStarted': 'Výroba zahájena',
  'mock.note.productionStartedLine1': 'Výroba zahájena na Lince 1',
  'mock.note.productionStartedLine2': 'Výroba zahájena na Lince 2',
  'mock.note.productionDone': 'Výroba dokončena',
  'mock.note.productionDoneWaiting': 'Výroba dokončena, čeká na expedici',
  'mock.note.done': 'Dokončeno',
  'mock.note.nightShift': 'Noční směna',
  'mock.note.dispatched': 'Expedováno',
  'mock.note.dispatchedTwoTrucks': 'Expedováno – 2 kamiony',
  'mock.note.dispatchedDopravaPlus': 'Expedováno přes Doprava Plus',
  'mock.note.loadedDispatched': 'Naloženo a expedováno',
  'mock.note.loadedOnTruck1J4': 'Naloženo na kamion 1J4 9921',
  'mock.note.delivered': 'Doručeno',
  'mock.note.deliveredSigned': 'Doručeno a podepsáno',
  'mock.nodeAlert.vibrationOverThreshold': 'Vibrační senzor nad prahem',
  'mock.nodeAlert.bearingTemp78': 'Teplota ložiska stoupá – 78 °C',
  'mock.nodeAlert.crusherChamberWear72': 'Opotřebení komory drtiče 72 %',
  'mock.dm.hourAway': 'Jsem hodinu od vás',
  'mock.dm.gateReady': 'Rozumíme, brána PST bude připravena',
  'mock.dm.arriveIn45': 'Přijedu za 45 min',
  'mock.dm.holdSlot': 'Teď nejezděte, čekáme na uvolnění slotu',
  'mock.dm.waitingParking': 'OK, čekám na parkovišti',
  'mock.dm.slotFree': 'Můžete jet, slot je volný',
  'mock.dm.atGate': 'Jsem u brány',
  'mock.dm.goToScale': 'Zajeďte na váhu',
  'mock.dm.loadingDone': 'Nakládka hotová?',
  'mock.dm.goToExitScale': 'Ano, jeďte na výjezdní váhu',
  'mock.dm.delay30': 'Odložte příjezd o 30 min',
  'mock.dm.arriveLater': 'Rozumím, přijedu později',
  'mock.dm.eta45': 'ETA 45 minut',
  'mock.dm.preparingCLS': 'Děkujeme, připravujeme slot CLS',
  'mock.ote.historicalLabel': '12. 5. 2024 (neděle)',
  'mock.ote.typicalLabel': 'Typický pracovní den',
  'mock.equipment.crusher': 'Drtič',
  'mock.day.Po': 'Po',
  'mock.day.Út': 'Út',
  'mock.day.St': 'St',
  'mock.day.Čt': 'Čt',
  'mock.day.Pá': 'Pá',
  'mock.day.So': 'So',
  'mock.day.Ne': 'Ne',
  // ── Příjezdy a nakládky / urgence ──
  'arrivals.state.no-info': 'Bez informace',
  'arrivals.state.not-coming': 'Nepřijede',
  'arrivals.state.no-power': 'Bez výkonu',
  'arrivals.state.rescheduled': 'Přeplánováno',
  'arrivals.state.confirmed': 'Potvrzeno',
  'arrivals.state.en-route': 'Na cestě (GPS)',
  'arrivals.state.on-site': 'V areálu',
  'arrivals.state.loaded': 'Naloženo',
  'arrivals.channel.sms': 'SMS',
  'arrivals.channel.whatsapp': 'WhatsApp',
  'arrivals.channel.email': 'E-mail',
  'arrivals.channel.phone': 'Telefon',
  'arrivals.channel.voice': 'Hlasový hovor',
  'arrivals.channel.link': 'Odkaz pro řidiče',
  'arrivals.channel.gps': 'GPS',
  'arrivals.channel.system': 'Systém',
  'arrivals.channel.sap': 'SAP',
  'arrivals.perHour': 'Očekávané příjezdy po hodinách',
  'arrivals.perHourHint': 'Podle ETA, jinak podle plánu. Bez nakládkových oken, jen přehled špiček.',
  'arrivals.known': 'S informací',
  'arrivals.unknown': 'Bez informace',
  'arrivals.gateCapacity': 'Kapacita bran',
  'arrivals.filter.all': 'Vše',
  'arrivals.filter.attention': 'Vyžaduje pozornost',
  'arrivals.filter.open': 'Nenaloženo',
  'arrivals.filter.loaded': 'Naloženo',
  'arrivals.filter.risk': 'Vysoké riziko',
  'ai.risk.label': 'Riziko nepřijetí',
  'ai.risk.high': 'Vysoké riziko',
  'ai.risk.medium': 'Střední riziko',
  'ai.risk.low': 'Nízké riziko',
  'ai.risk.reason.carrier': 'Dopravce za 30 dní nepřijel bez avíza u {pct} % nakládek',
  'ai.risk.reason.noInfo': 'Zatím žádná informace od dopravce',
  'ai.risk.reason.noPower': 'Řidič je mimo pracovní dobu',
  'ai.risk.reason.rescheduled': 'Už jednou přeplánováno',
  'ai.risk.reason.confirmed': 'Dopravce potvrdil příjezd',
  'ai.risk.reason.enRoute': 'Auto je na cestě (GPS)',
  'ai.risk.reason.afternoon': 'Odpolední nakládka, víc nepřijetí',
  'ai.risk.reason.outOfHours': 'Dopravce {n}× za 30 dní mimo pracovní dobu řidiče',
  'ai.risk.reason.noPlate': 'Z importu, ještě bez SPZ',
  'ai.risk.note': 'Odhad z historie dopravce a dnešního stavu, ne trénovaný model.',
  'arrivals.type.all': 'Vše',
  'arrivals.type.silo': 'Sila',
  'arrivals.type.pallet': 'Palety',
  'arrivals.searchPlaceholder': 'Hledat SPZ, dopravce, řidiče, dodávku...',
  'arrivals.emptyFilter': 'Nic k zobrazení. Všechny nakládky v tomto filtru jsou vyřešené.',
  'arrivals.plan': 'Plán',
  'arrivals.eta': 'Příjezd',
  'arrivals.tomorrow': 'zítra',
  'arrivals.loadedAt': 'Naloženo',
  'arrivals.toPlanner': 'Předáno plánovači',
  'arrivals.powerFrom': 'výkon od',
  'arrivals.plannedToday': 'Plánováno dnes',
  'actions.bannerText': 'nakládek vyžaduje akci – urgence, telefonát nebo přeplánování.',
  'actions.open': 'Otevřít akce',
  'actions.title': 'Akce',
  'actions.progress': 'Vyřešeno',
  'actions.hint': 'Nakládky, u kterých je potřeba něco udělat. Co vyřešíte, z fronty zmizí.',
  'actions.empty': 'Vše vyřešeno',
  'actions.emptyHint': 'Žádná nakládka teď nevyžaduje akci.',
  'actions.urge': 'Urgovat',
  'actions.urged': 'Urgováno',
  'actions.urgedToast': 'Urgence odeslána dopravci',
  'actions.call': 'Zavolat',
  'actions.link': 'Odkaz dispečerovi',
  'actions.replan': 'Přeplánovat',
  'actions.resolve': 'Vyřešeno',
  'actions.newTime': 'Nový čas',
  'actions.replannedTo': 'Přeplánováno plánovačem na',
  'actions.note': 'Poznámka',
  'actions.notePlaceholder': 'Co se stalo (např. domluveno telefonicky)',
  'actions.resolvedNote': 'Vyřešeno plánovačem',
  'actions.confirm': 'Potvrdit',
  'arrivals.tabToday': 'Dnešní nakládky',
  'arrivals.readyToConnect': 'Připraveno k napojení',
  'arrivals.showTranscript': 'Zobrazit přepis hovoru',
  'arrivals.hideTranscript': 'Skrýt přepis',
  'arrivals.urgency.title': 'Urgence dopravců',
  'arrivals.urgency.rule': 'Kontrola ve 13:00 · eskalace po 30 min: 2. kanál → hlasový hovor',
  'arrivals.urgency.approval': 'Se schválením',
  'arrivals.urgency.approvalHint': 'Systém připraví zprávy, plánovač je odešle jedním klikem.',
  'arrivals.urgency.auto': 'Plně automaticky',
  'arrivals.urgency.autoHint': 'Systém urguje sám a plánovači hlásí jen to, co nevyřešil.',
  'arrivals.urgency.run': 'Spustit kontrolu 13:00',
  'arrivals.urgency.queue': 'K urgenci',
  'arrivals.urgency.sendAll': 'Urgovat vše',
  'arrivals.urgency.result': 'Nakládky bez informace',
  'arrivals.urgency.resultHint': 'Plánovač řeší jen to, co zbylo. Ruční obvolávání odpadá.',
  'arrivals.urgency.reset': 'Přehrát znovu',
  'arrivals.urgency.empty': 'Ve 13:00 systém porovná plán nakládek se skutečností a osloví dopravce, o kterých nic nevíme.',
  'arrivals.detail.carrier': 'Dopravce',
  'arrivals.detail.prefers': 'preferuje',
  'arrivals.detail.emailDemo': 'E-mail otevřen (demo)',
  'arrivals.detail.driver': 'Řidič',
  'arrivals.detail.name': 'Jméno',
  'arrivals.detail.power': 'Pracovní doba',
  'arrivals.detail.powerUnknown': 'neznámo',
  'arrivals.detail.fromPlant': 'od závodu',
  'arrivals.detail.parking': 'Parkoviště',
  'arrivals.detail.parkingJesenik': 'Záchytné parkoviště Jeseník',
  'arrivals.detail.loading': 'Nakládka',
  'arrivals.detail.order': 'Dodávka (SAP)',
  'arrivals.detail.customer': 'Zákazník',
  'arrivals.detail.material': 'Materiál',
  'arrivals.detail.type': 'Typ',
  'arrivals.detail.communication': 'Komunikace',
  'arrivals.detail.noMessages': 'Zatím žádná komunikace',
  'arrivals.detail.auto': 'automaticky',
  'arrivals.ai.confirmed': 'AI: potvrzeno, příjezd {time}',
  'arrivals.ai.rescheduled': 'AI: dnes ne, přeplánováno na zítra {time}',
  'arrivals.ai.noPower': 'AI: řidič bez výkonu, nakládka zítra 6:00, parkuje v Jeseníku',
  'arrivals.log.check': 'Kontrola 13:00: {total} nakládek bez informace. {gps} dohledána přes GPS, {queue} k urgenci.',
  'arrivals.log.gps': 'GPS: auto je {km} km od závodu, ETA {time}. Urgence není potřeba.',
  'arrivals.log.gpsShort': 'GPS: {km} km od závodu, ETA {time}',
  'arrivals.log.sapNew': 'Nová dodávka ze SAP {order}, přiřazena dopravci {carrier}.',
  'arrivals.log.escalate': '30 min bez odpovědi ({ids}): zkouším druhý kanál.',
  'arrivals.log.call': 'Hlasový hovor: {name}, {phone}',
  'arrivals.log.callNoAnswer': 'Hlasový hovor: {name} nezvedá. Předáno plánovači.',
  'arrivals.log.callNoAnswerShort': 'Hovor nepřijat, předáno plánovači',
  'arrivals.log.done': 'Urgence dokončena. Zbývá jen to, co musí řešit člověk.',

  // ── Help tips (#113) ──
  'help.label': "Nápověda",
  'help.states.title': "Stavy kamionů",
  'help.states.text': "Kolik kamionů je v jakém stavu. Zelená = v pořádku, oranžová = pozor, červená = problém. Klikněte na kamion v seznamu a uvidíte detail.",
  'help.perHour.title': "Příjezdy po hodinách",
  'help.perHour.text': "Kolik kamionů má přijet v každé hodině. Vysoký sloupec = fronta u vrátnice. Takovou hodinu stojí za to rozložit.",
  'help.filters.title': "Filtry",
  'help.filters.text': "Klikněte a uvidíte jen kamiony, které vás zajímají. Dalším klikem filtr zrušíte.",
  'help.actions.title': "Akce",
  'help.actions.text': "Co je teď potřeba udělat. Nahoře nejdůležitější. Vyřešte a položka zmizí.",
  'help.followUp.title': "Urgence dopravců",
  'help.followUp.text': "Ve 13:00 systém zkontroluje, kdo nepotvrdil zítřejší nakládku, a dopravci napíše. Vy nemusíte nikomu volat.",
  'help.approval.title': "Automaticky, nebo se schválením",
  'help.approval.text': "Automaticky: zprávy odejdou samy. Se schválením: nejdřív je uvidíte a potvrdíte jedním klikem.",
  'help.risk.title': "Riziko nepřijetí",
  'help.risk.text': "Odhad, jak moc hrozí, že kamion nedorazí. Počítá se z historie dopravce. Vysoké riziko = zavolejte mu dřív.",
  'help.announce.title': "Odkaz pro dispečera",
  'help.announce.text': "Pošle dopravci odkaz. Dispečer v něm sám vyplní SPZ a řidiče. Žádné přepisování z e-mailu.",
  'help.reply.title': "Simulovat odpověď",
  'help.reply.text': "Napište odpověď, jak by ji poslal dopravce, třeba „přijedeme až zítra“. AI ji přečte a navrhne, co změnit.",
  'help.replan.title': "Návrh přeplánování",
  'help.replan.text': "AI navrhne nový čas nakládky. Když souhlasíte, klikněte na Přijmout. Jinak nic nedělejte.",
  'help.voice.title': "Hovor AI hlasem",
  'help.voice.text': "AI zavolá dispečerovi a zeptá se na příjezd. Výsledek se sám zapíše k nakládce.",
  'help.doc.title': "Doklad z fotky",
  'help.doc.text': "Vyfoťte dodací list nebo CMR. AI z něj vytáhne čísla a zapíše je. Zkontrolujte a potvrďte.",
  'help.importPaste.title': "Vložení plánu",
  'help.importPaste.text': "Zkopírujte plán z Excelu nebo e-mailu a vložte ho sem. Systém z něj sám udělá nakládky.",
  'help.importPhoto.title': "Plán z fotky",
  'help.importPhoto.text': "Máte plán jen na papíře? Vyfoťte ho nebo nahrajte PDF. AI ho přepíše za vás.",
  'help.period.title': "Období",
  'help.period.text': "Vyberte, za jaké období chcete čísla vidět. Všechny grafy níže se přepočítají.",
  'help.kpis.title': "Hlavní čísla",
  'help.kpis.text': "Čtyři čísla, podle kterých poznáte, jestli to funguje. Šipka ukazuje změnu proti době před pilotem.",
  'help.ask.title': "Zeptejte se",
  'help.ask.text': "Napište otázku obyčejnou větou, třeba „Který dopravce nejvíc mešká?“. AI odpoví z čísel na téhle stránce.",
  'help.carriers.title': "Dopravci",
  'help.carriers.text': "Kdo jezdí dobře a kdo ne. Červená = často nepřijede. Klikněte na dopravce a uvidíte víc.",
  'help.value.title': "Hodnota pilotu",
  'help.value.text': "Kolik vám systém ušetří za měsíc. Čísla v rámečcích můžete přepsat podle sebe a výsledek se přepočítá.",
  'help.heatmap.title': "Kdy kamiony jezdí",
  'help.heatmap.text': "Tmavší políčko = víc kamionů v ten den a hodinu. Tak uvidíte, kdy je v areálu nejrušněji.",
  'help.reports.title': "Reporty",
  'help.reports.text': "Hotové přehledy na poradu. Stačí otevřít, vytisknout nebo poslat.",
  'help.rating.title': "Hodnocení dopravce",
  'help.rating.text': "Měsíční vysvědčení pro dopravce. Vytiskněte ho nebo pošlete jako PDF. Nápověda se netiskne.",
  'help.energy.title': "Plán mletí",
  'help.energy.text': "AI navrhne, kdy mlít, aby to vyšlo na levnou elektřinu. Když se vám plán líbí, převezměte ho.",
  'help.ai.title': "AI, nebo AI demo",
  'help.ai.text': "AI = odpověď právě vytvořil Claude. AI demo = připravená ukázková odpověď, když AI není zapnutá.",
  // ── Site now (#115) ──
  'site.title': "Areál teď",
  'site.summary': "Aut v areálu: {total}.",
  'site.lateSummary': "{late} z nich tu je déle než {limit} minut.",
  'site.lateHint': "Stojí tu moc dlouho. Zjistěte proč – čekání stojí peníze.",
  'site.onSite': "v areálu",
  'site.empty': "Nikdo",
  'site.zone.queue': "Fronta u brány",
  'site.zone.PST': "Nakládka PST (palety)",
  'site.zone.CLS': "Nakládka CLS (sila)",
  'site.zone.weighbridge': "Váha",
  'help.siteNow.title': "Areál teď",
  'help.siteNow.text': "Kdo je právě v areálu a kde stojí. Velké číslo = jak dlouho na tom místě, malé = jak dlouho v areálu celkem. Červená = déle než 45 minut, klikněte a řešte.",
  // ── Today's sections (#117) ──
  'arrivals.section.action': "Potřebuje akci",
  'arrivals.section.onSite': "V areálu",
  'arrivals.section.enRoute': "Na cestě",
  'arrivals.section.confirmed': "Potvrzeno",
  'arrivals.section.later': "Přesunuto na jindy",
  'arrivals.section.loaded': "Naloženo",
  'arrivals.typeLabel': "Typ",
  // ── Recommended action (#118) ──
  'actions.more': "Další…",
  'actions.recommended': "Doporučeno",
  'actions.reason.noInfo': "dopravce se zatím neozval, pošlete mu zprávu.",
  'actions.reason.noAnswer': "urgovali jste a odpověď nepřišla, zavolejte.",
  'actions.reason.noPower': "řidiči došla pracovní doba, nakládku přesuňte.",
  'arrivals.urgency.bar.idle': "Kontrola ještě neproběhla.",
  'arrivals.urgency.bar.review': "Zprávy čekají na odeslání.",
  'arrivals.urgency.bar.done': "Kontrola je hotová.",
  'arrivals.urgency.bar.sending': "Odesílám zprávy dopravcům…",
  'arrivals.urgency.barToggle': "Zobrazit průběh urgence",
};

export function t(key) {
  return cs[key] || key;
}

export default cs;
